import React from 'react';
import { ButtonProps } from '@/types/components';

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'medium',
  disabled = false,
  className = '',
}) => {
  const baseClasses =
    'inline-flex items-center justify-center font-medium rounded-md focus:outline-hidden focus:ring-2 focus:ring-offset-2 transition-colors';

  const variantClasses = {
    primary: 'bg-primary text-static-white bg-primary-hover focus:ring-primary',
    secondary:
      'bg-(--primary-alpha-10) text-primary hover:bg-(--primary-alpha-16) focus:ring-primary',
    danger:
      'bg-error-base text-static-white hover:bg-error-dark focus:ring-error-base',
    neutral:
      'bg-bg-soft-200 text-text-strong-950 hover:bg-bg-sub-300 focus:ring-stroke-sub-300',
    white:
      'bg-bg-white-0 border border-stroke-sub-300 hover:bg-bg-weak-50 focus:ring-stroke-sub-300',
  };

  const sizeClasses = {
    small: 'px-3 py-1.5 text-sm',
    medium: 'px-4 py-2 text-sm',
    large: 'px-6 py-3 text-base',
  };

  const disabledClasses = disabled
    ? 'disabled:bg-bg-weak-50 disabled:text-text-disabled-300 disabled:cursor-not-allowed'
    : '';

  const variantClass =
    !disabled && variant && variantClasses[variant]
      ? variantClasses[variant]
      : '';

  const classes =
    `${baseClasses} ${variantClass} ${sizeClasses[size]} ${disabledClasses} ${className}`.trim();

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classes}
    >
      {children}
    </button>
  );
};

export default Button;
